/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e,{timeZone:t,timeExtent:r}){return{$view:{scale:e,timeZone:t,timeProperties:{currentStart:r?.start,currentEnd:r?.end}}}}export{e as createArcadeEvaluationOptions};
